import axios from "axios";
import Config from "../common/Config";
import FieldState from "../common/FieldState";
import OrderFormStep from "../common/OrderFormStep";
import FormTitle from "../components/formTitle/FormTitle";
import MuiRadio from "../components/radio/MuiRadio";
import Button from "../components/button/Button";
import SecondaryButton from "../components/button/SecondaryButton";
import { CreateNotification } from "../components/notification/Notification";
import SaveAsDraft from "../components/modal/SaveAsDraft";
import { Table } from "react-bootstrap";
import TextField from '@material-ui/core/TextField';
import ClearOrder from "../components/modal/ClearOrder";

export default class MultipleDesignerLinerSelection extends OrderFormStep {
  constructor(props) {
    super(props);

    this.state = {
      clearOrderButtonSelected: false,
      openClear: false,
      showClear: true,
      accountNumber: localStorage.getItem("accountNumber"),
      isSubmit: false,
      isLoaded: false,
      linerCreationTypes: [],
      newCreationType: null,
      formState: {
        linerCreationType: new FieldState(true),
        currentLiners: [],
        patientId: new FieldState(false),
      },
    };

    this.selectedValue = "0"
    this.creationTypeNewId = 531
    this.creationTypeDuplicateId = 532;

    this.addLinerFromPartNumber = this.addLinerFromPartNumber.bind(this);
    this.addFromSerialNumber = this.addFromSerialNumber.bind(this);
    this.loadCart = this.loadCart.bind(this);
  }

  setServerLinerQuantity(partNumber, quantity, formIndex) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    const fromDuplicate = this.state.formState.linerCreationType.value === this.creationTypeDuplicateId;

    axios.post(
      Config.baseApiUrl + "designLinerQuantity/" + this.props.formTypeId + '?fromDuplicate=' + fromDuplicate + "&formIndex=" + formIndex, {
      partnumber: partNumber,
      quantity: quantity
    },
      config
    ).then(response => {
      if (response.data.success) {
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }

  setLocalLinerQuantity(partNumber, formIndex, quantity) {
    var formState = this.state.formState
    var liners = formState.currentLiners;
    liners = this.state.formState.currentLiners.map((liner) => {
      if (liner.partNumber === partNumber && liner.formIndex === formIndex) {
        liner.quantity = quantity;
      }

      return liner;
    });

    formState.currentLiners = liners;
    this.setState({
      formState: formState
    });
  }

  addLinerFromPartNumber() {
    var formState = this.state.formState;

    let partNumber = formState.newLinerPartNumber.value;
    let quantity = formState.linerQuantityNew.value;

    this.addLinerRequest(partNumber, quantity);

    formState.newLinerPartNumber.value = "";
    formState.linerQuantityNew.value = 1;

    this.setState({
      formState: formState
    });
  }

  addFromSerialNumber() {
    var formState = this.state.formState;

    let partNumber = formState.duplicateLinerPartNumber.value;
    let quantity = formState.linerQuantityDuplicate.value;

    this.addLinerRequest(partNumber, quantity, true);

    formState.linerQuantityDuplicate.value = 1;

    this.setState({
      formState: formState
    });
  }

  addLinerRequest(partNumber, quantity, fromSerial = false) {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    axios.post(
      Config.baseApiUrl + "designLiner/" + this.props.formTypeId + '?fromSerial=' + fromSerial + '&formIndex=' + this.props?.formIndex,
      {
        partnumber: partNumber,
        quantity: quantity
      },
      config
    ).then(response => {
      if (response.data.success) {
        this.loadCart();
      } else {
        CreateNotification(response.data.message, "error");
      }
    });
  }

  async loadCart() {
    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };
    var saveLiners = (cartData) => {
      let liners = cartData.map((item) => {
        if (item === null) {
          return null;
        }
        return {
          name: item.name,
          partNumber: item.partNumber,
          quantity: item.quantity,
          formIndex: item.formIndex,
          serialNumber: item.serialNumber,
          footSide: item.footSide,
        };
      });

      let linersToDisplay = []
      if (this.state.formState.linerCreationType.value === this.creationTypeNewId) {

        const groupedLiners = Object.groupBy(liners, ({formIndex}) => {
            return formIndex
        });
        const groupedList = Object.entries(groupedLiners).map(([key, values]) => ({
          key,
          values
        }));
        for (let i = 0; i < groupedList.length; i++) {
          groupedList[i].values.forEach(l => {
            let liner = l;
            let duplicateDesignLinerPartNumber = ""
            switch (l.partNumber) {
              case "ALL-DES-OT":
              case "ALL-DES-EO":
                duplicateDesignLinerPartNumber = "ALL-DES-DP";
                break;
              case "ALC-DES-OT":
              case "ALC-DES-EO":
                duplicateDesignLinerPartNumber = "ALC-DES-DP";
                break;
              case "ADC-DES-OT":
              case "ADC-DES-EO":
                duplicateDesignLinerPartNumber = "ADC-DES-DP";
                break;
              default:
                break;
            }
            if (duplicateDesignLinerPartNumber === "") {
              return;
            }
            const duplicateQuantity = groupedList[i].values.find(l => l.partNumber === duplicateDesignLinerPartNumber)?.quantity ?? 0;
            liner.quantity += duplicateQuantity;
            linersToDisplay.push(liner)
          })
        }
      } else {
        linersToDisplay = liners.filter(l => l.partNumber !== "DES-SETUP");
      }

      var formState = this.state.formState;
      formState.currentLiners = linersToDisplay;

      this.setState({
        formState: formState
      });
    }
    saveLiners = saveLiners.bind(this);

    if (this.props.isBilateral) {
      await axios.all([
        axios.get(
          Config.baseApiUrl + "cart/" + this.props.formTypeId + '?formIndex=' + 0,
          config
        ),
        axios.get(
          Config.baseApiUrl + "cart/" + this.props.formTypeId + '?formIndex=' + 1,
          config
        )]).then(response => {
          const merge = response[0].data.concat(response[1].data);
          saveLiners(merge);
          this.props.loadCart(true);
        }).catch(error => {
          console.log(error)
        });
    } else {
      await axios.get(
        Config.baseApiUrl + "cart/" + this.props.formTypeId,
        config
      ).then(response => {
        saveLiners(response.data);
        this.props.loadCart(true);
      }).catch(error => {
        console.log(error)
      });
    }
  }

  onInputChange(e, id) {
    let formState = this.state.formState;
    formState[id].value = e.target.value;
    this.setState({
      formState: formState,
      hasDataChanged: true,
    });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData() {
    let header = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    }

    this.setState({
      linerCreationTypes: (
        await axios.get(
          Config.baseApiUrl + "fieldOptions/" + this.props.formTypeId,
          { params: { fieldName: "linerCreationType" } }
        )
      ).data,
      patientInfo: (
        await axios.get(
          Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId, {
          headers: header,
        })
      ).data,
    });

    let config = {
      headers: header,
      params: {
        fieldNames: [
          "linerCreationType",
        ],
      },
    };

    let formState = this.state.formState;

    if (this.state.patientInfo !== null) {
      formState.patientId.value = this.state.patientInfo.patientId;
    }

    let response = null
    if (!this.props.isBilateral) {
      response = await axios.get(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        config
      );
    } else {
      response = await axios.get(
        Config.baseApiUrl + "fieldInputs?id=" + this.props.formTypeId + "&formIndex=" + this.props.formIndex,
        config
      );
    }

    const { data } = response
    if (data !== null) {
      formState.linerCreationType.value = data.find(
        (fi) => fi.fieldName === "linerCreationType"
      ).fieldOptionId;
    }

    this.setState({ formState: formState })

    await this.loadCart();
    this.setState({ isLoaded: true });
  }

  async saveData() {
    let data = [];

    data.push({
      fieldName: "linerCreationType",
      fieldOptionId: this.state.formState.linerCreationType.value,
    });

    let patientData = {
      isBilateral: this.props.isBilateral,
      accountNumber: this.state.accountNumber,
      patientId: this.state.formState.patientId.value,
      fieldInputs: [],
    };

    let config = {};
    config.headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("token")).access_token,
    };

    if (!this.props.isBilateral) {
      return axios.post(
        Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId,
        data,
        config
      ).then(() => {
      return axios.post(
        Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
        patientData,
        config
      )
      }).then((response) => {
        return response;
      })
    } else {
      return axios.post(
        Config.baseApiUrl + "patientInfo1s/" + this.props.formTypeId,
        patientData,
        config
      ).then(() => {
        return axios.post(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId + '?formIndex=0',
          data,
          config
        )
      }).then(() => {
        return axios.post(
          Config.baseApiUrl + "fieldInputs/" + this.props.formTypeId + '?formIndex=1',
          data,
          config
        )
      }).then((response) => {
        return response;
      })
    }
  }

  handleClickClearOpen = (e) => {
    this.setState({ newCreationType: e })
    this.setState({ openClear: true })
  };

  handleClickClearOpenFromBtn = () => {
    this.setState({ openClear: true })
    this.setState({ clearOrderButtonSelected: true })
  };

  handleCloseClear = () => {
    this.setState({ openClear: false })
    this.setState({ showClear: true })
    this.setState({ clearOrderButtonSelected: false })
  };

  setShowClear = (value) => {
    let patientInfo = this.state.patientInfo
    patientInfo.isBilateral = this.props.isBilateral
    this.setState({ patientInfo: patientInfo })
    this.setState({ showClear: value })
  }

  handleClearBack = () => {
    if (!this.state.clearOrderButtonSelected) {
      if (this.state.newCreationType !== null) {
        this.onRadioChange(this.state.newCreationType, "linerCreationType");
        this.props.setActiveInnerStep(1)
      } else {
        let formState = this.state.formState
        formState.linerCreationType.value = null;
        this.setState({ formState: formState })
      }
      this.loadCart();
    } else {
      this.setState({ newCreationType: null })
      this.props.setActiveInnerStep(1)
      window.location.reload()
    }
  };

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  onRadioChange(e, field) {
    super.onRadioChange(e, field);

    let formState = this.state.formState;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    return (
      <>
        <div className="checkFormWrapper">
          <FormTitle
            title="Form Type Selection"
            description=""
          />

          <form className="checkform" onSubmit={e => { e.preventDefault() }}>
            <div className="radioGroup m-0"></div>

            <div className="fieldBorder">
              {this.state.isBilateral ?
                <h4 className="headLable"><b>First Liner</b></h4> :
                <></>
              }
              <MuiRadio
                options={this.state.linerCreationTypes}
                defaultValue={this.state.formState.linerCreationType.value}
                required={this.state.formState.linerCreationType.isRequired}
                error={
                  this.handleError("linerCreationType") && this.state.isSubmit
                }
                label="Liner Order Type"
                onChange={(e) => {
                  if (this.state.formState.currentLiners.length > 0) {
                    this.handleClickClearOpen(e)
                  } else {
                    this.onRadioChange(e, "linerCreationType");
                    this.props.setActiveInnerStep(1)
                  }
                }}
              />
            </div>

            {this.state.formState.currentLiners.length > 0 &&
              <div>
                <br />
                <div className="msgBox msgBoxWidth">
                  <h4 className="headLable"><b>Current Liners in Cart</b></h4>
                </div>
                <br />
                <Table className="transparent-table">
                  <thead>
                    <tr>
                      <th><b>Liner</b></th>
                      <th></th>
                      <th><b>Part Number</b></th>
                      <th><b>Quantity</b></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.formState.currentLiners.map((liner, index) => {
                      if (liner === null) {
                        return "";
                      }

                      return (
                        <tr key={index}>
                          <td lg="6" sm="1">
                            <div>{liner.name}</div>
                            <div>{liner.serialNumber !== "" ? `Serial Number: ${liner.serialNumber}` : ""}</div>
                            <div>{liner.footSide !== "" ? `Side: ${liner.footSide}` : ""}</div>
                          </td>
                          <td></td>
                          <td>
                            <div>{liner.partNumber}</div>
                          </td>
                          <td>
                            <TextField
                              type={"number"}
                              onChange={(e) => this.setLocalLinerQuantity(liner.partNumber, liner.formIndex, e.target.value)}
                              onBlur={() => this.setServerLinerQuantity(liner.partNumber, liner.quantity, liner.formIndex)}
                              value={liner.quantity}
                            />
                          </td>
                          <td><SecondaryButton
                            text="Remove"
                            onClick={() => this.setServerLinerQuantity(liner.partNumber, 0, liner.formIndex)}
                          />
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            }
          </form>
        </div>

        <div className="handelButtons">
          <SecondaryButton
            text="Clear the Order?"
            onClick={this.handleClickClearOpenFromBtn}
          />
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              disabled={this.props.disableBackButton}
              onClick={() => {
                this.props.handleBack(this?.props?.currentIndex - 1);
                if (this.props.setIsBack) {
                  this.props.setIsBack(true);
                }
              }}
            />
            <Button
              text="Next"
              disabled={!this.state.isLoaded}
              onClick={async () => {
                if (this.validateData().isValid) {
                  let totalNoOfLiners = 0;
                  if (this.state.formState.currentLiners !== null) {
                    this.state.formState.currentLiners.forEach(cl => {
                      if (this.props.formIndex === cl.formIndex) {
                        totalNoOfLiners += parseInt(cl.quantity);
                      }
                    })
                  }

                  try {
                    this.setState({ isLoaded: true });

                    const res = await this.saveData();
                    if (res.status === 204) {
                      if (this.props.isBilateral !== null && this.props.isBilateral) {
                        this.props.handleNext(this.props.currentIndex, this.props.orderIndex);
                      } else {
                        this.props.handleNext()
                      }
                    }
                  } catch (err) {
                    this.setState({ isLoaded: true });
                  }
                } else {
                  this.setState({
                    isSubmit: true,
                  });
                  CreateNotification(this.validateData().errorMessage, "error");
                  this.setState({ isLoaded: true });
                }
              }}
            />
          </div>

        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.state.openClear}
          handleCloseClear={this.handleCloseClear}
          showClear={this.state.showClear}
          setShowClear={this.setShowClear}
          formId={this.props.formTypeId}
          handleClearBack={this.handleClearBack}
          customMessage={
            !this.state.clearOrderButtonSelected ?
            this.state.formState.linerCreationType.value === this.creationTypeNewId ?
              "You have a New Order in progress. To initiate a Duplicate Order you must clear your form. Proceed?" :
              "You have a Duplicate Order in progress. To initiate a New Order you must clear your form. Proceed?"
              : null
          }
        />
      </>
    );
  }
}
